<template>
  <div id="loader">
     <!-- <img src="@/assets/front/images/logo.svg" alt="" />  :class="{hide: isHidden}"-->
     <div class="LoadingSvgCircle"  style="height:100px"> 
      <svg class="position-absolute mx-auto running" viewBox="-2 -2 64 64" width="100" height="100" style="left:0;right:0"> 
        <path d="M30 0A30 30 0 0 1 60 30M30 60A30 30 0 0 1 0 30" fill="none" stroke="#ed1c24" stroke-width="2" transform="rotate(101.533 30 30)"> <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" keyTimes="0;1" values="0 30 30;180 30 30" keySplines="0.5 0 0.5 1" calcMode="spline"></animateTransform> 
        </path> 
      </svg> 
      <div class="ldBar m-auto position-absolute" id="building-progress" data-path="M0 0A15 15 0 0 1 0 30A15 15 0 0 1 0 0" data-value="0" data-bbox="-17 -5 34 40" data-padding="0" style="left:0;right:0;width:100px;height:100px"> 
        <svg xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="100%" height="100%" viewBox="-17 -5 34 40"> <defs>
         <filter id="ldBar-5be742f5cd2c7-filter" x="-1" y="-1" width="3" height="3">
           <feMorphology operator="dilate" radius="3"></feMorphology> 
           <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" result="cm"></feColorMatrix> 
          </filter> 
          <mask id="ldBar-5be742f5cd2c7-mask"> 
            <image xlink:href="" filter="url(#ldBar-5be742f5cd2c7-filter)" x="0" y="0" width="100" height="100" preserveAspectRatio="xMidYMid"></image> 
          </mask> 
            <g> 
              <mask id="ldBar-5be742f5cd2c7-mask-path">
               <path d="M0 0A15 15 0 0 1 0 30A15 15 0 0 1 0 0" fill="#fff" stroke="#fff" filter="url(#ldBar-5be742f5cd2c7-filter)"></path>
               </mask> 
            </g> 
               <clipPath id="ldBar-5be742f5cd2c7-clip"> <rect class="mask" fill="#000"></rect>
               </clipPath> 
               <pattern id="ldBar-5be742f5cd2c7-pattern" patternUnits="userSpaceOnUse" x="0" y="0" width="300" height="300"> <image x="0" y="0" width="300" height="300"></image> 
              </pattern> </defs> 
              <g> <path d="M0 0A15 15 0 0 1 0 30A15 15 0 0 1 0 0" fill="none" class="baseline" stroke="#ddd" stroke-width="0.5"></path> 
              </g> 
              <g>
                <path d="M0 0A15 15 0 0 1 0 30A15 15 0 0 1 0 0" class="mainline" clip-path="" fill="none" stroke-width="2" stroke="#cc1017"  stroke-Dasharray="0.1 100" ></path> 
              </g> 
        </svg>
             <i class="bgDericLoading"></i> 
               <div class="ldBarlabel">
                </div> 
         </div>
         </div> 
         <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      :stroke="color"
      stroke-linecap="round"
      :stroke-width="border"
      :d="path"
    />
  </svg> -->

  </div>
</template>

<style scoped>
.LoadingSvgCircle {
    position: fixed !important;
    width: 100% !important;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100% !important;
    margin: 0;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000000000000000000000000;
}

    .LoadingSvgCircle.hide {
        opacity: 0;
        pointer-events: none;
        transition: all 0.5s;
    }

.ml-auto, .mx-auto {
    margin-left: auto !important;
}

.mr-auto, .mx-auto {
    margin-right: auto !important;
}

.position-absolute {
    position: absolute !important;
}

.m-auto {
    margin: auto !important;
}

.ldBar {
    position: relative;
}

    .ldBar .bgDericLoading {
        position: absolute;
        width: 55px;
        height: 55px;
         background: transparent url("../../../assets/front/images/logo.svg") no-repeat center / 100%; 
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
    }

.ldBarlabel {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    right: 0;
    margin: auto;
    width: 100px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #F44336;
    border-radius: 6px;
    color: #ffffff;
    font-weight: bold;
    box-shadow: 0px 0px 15px -5px #F44336;
}

    .ldBarlabel:after {
        content: "%";
        display: inline;
    }
    @keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  20% {
    transform: rotate(50deg);
  }
  80% {
    transform: rotate(310deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

svg {
  animation: rotate 1.8s linear infinite;
}
</style>


<script type="javascript" >

//import { BIconApp } from 'bootstrap-vue';


 var width = 100,
    perfData = performance.getEntriesByType("resource") ,//window.performance.timing, // The PerformanceTiming interface represents timing-related performance information for the given page.
    EstimatedTime = -(perfData.loadEventEnd - perfData.navigationStart),
           time = parseInt((EstimatedTime/1000)%60)*100;
 var PercentageID = document.getElementById('precent'),//$("#precent"),
         start = 0,
         end = 100,
         durataion = time;
         animateValue(PercentageID, start, end, durataion);
  function animateValue(id, start, end, duration) {

     var range = end - start,
       current = start,
        increment = end > start? 1 : -1,
        stepTime = Math.abs(Math.floor(duration / range));
        //obj =  document.getElementById('precent');//id;//$(id);
    
     var timer = setInterval(function() {
         current += increment;
         // $(obj).text(current + "%");
         //obj.innerText(current + "%");
        // document.getElementById('precent').title(current + "%");
       // document.querySelector("#precent").innerHTML = "<i>"+ current + "%" +"</i>";
         
          //$(".LoadingSvgCircle").find('path.mainline').attr("stroke-dasharray", current +" "+ parseInt((100 - current)));
         //document.getElementsByClassName('mainline').style.stroke = current +" "+ parseInt((100 - current));
         
          //$(".LoadingSvgCircle").find(".ldBar-label").html(current);
        // document.getElementsByClassName('ldBarlabel').innerHTML(current);
          let specs = document.getElementsByClassName("ldBarlabel");
         for(let i = 0 ; i < specs.length;i++){
             specs[i].innerHTML = "<i>"+ current +"</i>";
           }
       // document.querySelector(".ldBarlabel").innerHTML = "<i>"+ current +"</i>";

         //this.currentDiv=current;
         var horizontals = document.getElementsByClassName('mainline');

for (var i = 0; i < horizontals.length; i++ ) {
    var path = horizontals[i],
        length = path.getTotalLength();
        path.style.strokeDasharray =  current +" "+ parseInt((100 - current));
        path.style.strokeDashoffset = length; 
}

        //obj.innerHTML = current;
          if (current == end) {
             clearInterval(timer);
             //$(".LoadingSvgCircle").addClass("hide");
             //document.getElementsByClassName('LoadingSvgCircle').addClass("hide");
            // var x = document.getElementsByClassName('LoadingSvgCircle');
             //var i;
            // for (i = 0; i < x.length; i++) 
             //{
             //   x[i].className += ' hide'; // WITH space added
             //}
            }
      }, stepTime);
  }

</script>


 <style scoped>
#loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
  background: #000000e0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10000000;
 
}
#loader img {
  position: relative;
  animation:moveLogo 1.5s infinite linear alternate
}
@keyframes moveLogo {
  from {
    bottom: 50px;
  }
  to {
    bottom: 120px;
  }
}
</style> 
